import { Base } from "src/app/shared/model/core/base.model";

export class Prospeccion extends Base {

    public id: number;
	public cliente: number;
	public fechaInicio: Date;
	public descripcion: string;
	public fechaTerminacion: Date;
	public causa: string;
    public razonsocial: string;
	public compromisoSeguimiento: string;
	public actividadSeguimiento: string;
	public estatus: string;
	public id_usuario: number;

}